/**
 * Email Domain Typo Detection Utility
 */

// Gmail domain typos only
const GMAIL_TYPOS = {
  'gamil.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmil.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'gmeil.com': 'gmail.com',
  'gmaul.com': 'gmail.com',
  'gmali.com': 'gmail.com',
  'gmaik.com': 'gmail.com',
  'gmain.com': 'gmail.com',
  'gmaio.com': 'gmail.com',
  'gmaip.com': 'gmail.com',
  'gmait.com': 'gmail.com',
  'gmaiy.com': 'gmail.com',
  'gmaol.com': 'gmail.com',
  'gmsil.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gail.com': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.cmo': 'gmail.com',
  'gmail.cm': 'gmail.com',
  'gmail.om': 'gmail.com',
  'gmail.co.': 'gmail.com',
  'gmail.c': 'gmail.com',
  'gmail.comm': 'gmail.com',
  'gmail.coom': 'gmail.com'
};

/**
 * Check if email has a Gmail domain typo
 * @param {string} email - The email address to check
 * @returns {object} - Object with hasTypo boolean
 */
export function checkEmailDomainTypo(email) {
  if (!email || typeof email !== 'string') {
    return { hasTypo: false };
  }

  const atIndex = email.lastIndexOf('@');
  if (atIndex === -1) {
    return { hasTypo: false };
  }

  const domain = email.substring(atIndex + 1).toLowerCase().trim();

  // Check if it's a Gmail typo
  return { hasTypo: domain in GMAIL_TYPOS };
}

export default {
  checkEmailDomainTypo
};
